<template>
  <div v-if="theme">
    <label class="form-control-label">
      <h4>Theme Name</h4>
    </label>
    <input
      ref="name"
      type="text"
      v-model="name"
      maxlength="255"
      @change="update"
      :disabled="!canEdit"
      class="form-control"
    />
    <nameValidation :$v="$v" />
  </div>
</template>

<script>
import { prizepoolService } from "@/api/client";
import nameValidation from "@/views/prize/theme/validation/name.vue";
import { FormEditValidateRule as validateRules } from "@/views/prize/theme/validation";

export default {
  props: ["theme"],

  components: {
    nameValidation,
  },

  validations: { name: validateRules.name },

  data() {
    return {
      id: null,
      name: null,
    };
  },

  computed: {
    canEdit() {
      return ["active", "inactive"].includes(this.theme.status);
    },
  },

  mounted() {
    this.id = this.theme.id;
    this.name = this.theme.name;
  },

  methods: {
    async isFormValid() {
      if (this.$v.name.$invalid) {
        await this.$dialogs.alert("กรุณากรอก Theme Name ให้ถูกต้อง");
        this.$refs.name.focus();
        return false;
      }
      return true;
    },

    async update() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        await prizepoolService.updatePrizeTheme(this.theme.id, {
          name: this.name,
        });
        this.$notify(`Theme name updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Upload Theme name error.`);
      }
    },
  },
};
</script>

<style></style>
